import { LitEntity, html } from '../../utility/lit-entity';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import '../../common/bn-action';

class RejectWorkOrderModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'reject-work-order-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#reject-work-order-modal {
          --modal-min-width: 25%;
          --modal-max-width: 600px;
        }
        h3 {
          margin: 0;
        }
      </style>

      <h3 slot="title">Reject Work Order</h3>

      <p>Please provide the reason you are rejecting this work order. This will be displayed to the installation partner.</p>
      <bn-action
        .href="${this.href}"
        buttonstyle='outlinedError'
        suppressheader
        actionname="reject-work-order"
        submittext="Reject"
        @response="${this._onResponse}"
      >
        <span slot="header"></span>
      </bn-action>
    `;
  }

  _onResponse(e) {
    this.dispatchEvent(new CustomEvent('response', { detail: e.detail }));
    this.close();
  }
}

window.customElements.define('reject-work-order-modal', RejectWorkOrderModal);
